<div class="modal-header no-padding">
    <i class="bi bi-check-circle-fill" style="color: white;"></i>
    <div class="title">{{ modalTitle }}</div>
    <button type="button" class="close" aria-label="Close" style="color: white;"
        (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>